import { animate } from 'motion';

export function motionCount(countElement) {
    // Grab some values as a string from item data attr and convert to an number for use
    const start = +countElement.getAttribute('data-start') || 0;
    const end = countElement.getAttribute('data-end') || 0;
    const duration = +countElement.getAttribute('data-duration') || 0.25;
    // Split all of the characters (e.g ',' or '.' '12,500.45') so we can animate each number individually
    const characters = end.split('');

    // Empty the container
    countElement.innerHTML = '';

    // Loop over each character, create a new container, add that container to original container
    // If character is a number when converting using the '+' then we animate with a slight stagger
    // Else just append the original character (','; '.' or ' ') back in
    characters.forEach((character, index) => {
        const span = document.createElement('span');
        countElement.appendChild(span);

        if (character.trim() === '') {
            span.innerHTML = '&nbsp';
        } else if (isNaN(+character)) {
            span.innerHTML = character;
        } else {
            animate(start, +character, {
                duration: duration + (index * 0.01),
                ease: 'linear',
                onUpdate: (latest) => {
                    span.innerHTML = Math.round(latest);
                },
            });
        }
    });
}